import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>The patient does not qualify under the current benefit limit.</p>
			</div>
		);		
	}
}